import { PruHttpService } from "../services/pru-http.service";
import { of } from "rxjs";
import { SessionStorageService } from "../services/web-storage/session-storage.service";
import { shareReplay, map, catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "./pru-http.service";
import * as i2 from "./web-storage/session-storage.service";
var FeatureListService = /** @class */ (function () {
    function FeatureListService(_pruhttp, _sessionStorageService) {
        this._pruhttp = _pruhttp;
        this._sessionStorageService = _sessionStorageService;
        this.strURL = environment.userEnabledFeatures;
        this.key = "toggleFeatureList";
        this.enabledKey = "enabledFeature";
    }
    FeatureListService.prototype.getFeatureList = function () {
        var _this = this;
        if (this.toggleFeatureList) {
            return of(this.toggleFeatureList);
        }
        // Check if Session Exists
        if (this._sessionStorageService.getItem(this.key)) {
            this.toggleFeatureList = this._sessionStorageService.getItem(this.enabledKey, true) || [];
            return of(this.toggleFeatureList);
        }
        else {
            return this._pruhttp.get(this.strURL, "feature-toggle").pipe(map(function (data) {
                _this._sessionStorageService.setItem(_this.key, data, true);
                _this.toggleFeatureList = [];
                if (data["body"]) {
                    data["body"].forEach(function (item) {
                        if (/enable/i.test(item.featureStatus)) {
                            _this.toggleFeatureList.push(item.featureName);
                        }
                    });
                    if (_this.toggleFeatureList.length) {
                        _this._sessionStorageService.setItem(_this.enabledKey, _this.toggleFeatureList, true);
                    }
                }
                return _this.toggleFeatureList;
            }), catchError(function (error) {
                console.log("feature toggle error: ", error);
                return of([]);
            }), shareReplay());
        }
    };
    FeatureListService.ngInjectableDef = i0.defineInjectable({ factory: function FeatureListService_Factory() { return new FeatureListService(i0.inject(i1.PruHttpService), i0.inject(i2.SessionStorageService)); }, token: FeatureListService, providedIn: "root" });
    return FeatureListService;
}());
export { FeatureListService };
